import { Injectable } from '@angular/core';

import * as _ from 'lodash';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';

import { Logger } from '../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McLisMeasureService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  loadMeasure(id: string) {
    return this.sdk.lis.measures().get(id);
  }

  createMeasure(data: any) {
    const values = _.pick(data, ['name', 'set', 'type', 'description', 'unit', 'test', 'hl7IdentifierCod', 'hl7IdentifierSys']);
    return this.sdk.lis.measures().create(values);
  }

  updateMeasure(id: string, data: any) {
    const values = _.pick(data, ['name', 'set', 'type', 'description', 'unit', 'hl7IdentifierCod', 'hl7IdentifierSys']);
    return this.sdk.lis.measures().update(id, values);
  }

  removeMeasure(id: string) {
    return this.sdk.lis.measures().remove(id);
  }

  /**
   * Remove a specific reference value inside a lis-measure
   * @param id 
   * @param refValue 
   */
  removeRefValueOfMeasure(id: string, refValue: any) {
    const update: any = { $pull: { referenceRanges: { id: refValue.id } } };
    return this.sdk.lis.measures().update(id, update);
  }

  createRefValueOfMeasure(id: string, data: any) {
    const refValue: any = _.pick(data, ['min', 'max', 'ageMin', 'ageMax', 'sex']); 
    const update2: any = { $addToSet: { referenceRanges: refValue } };
    return this.sdk.lis.measures().update(id, update2);
  }

  async updateRefValueOfMeasure(id: string, data: any) {
    const refValue: any = _.pick(data, ['min', 'max', 'ageMin', 'ageMax', 'sex']); 
    
    // remove item
    if (data.id) {
      const update1: any = { $pull: { referenceRanges: { id: data.id } } };
      await this.sdk.lis.measures().update(id, update1);
    }
    
    // add item
    const update2: any = { $addToSet: { referenceRanges: refValue } };
    return this.sdk.lis.measures().update(id, update2);
  }
}
